import React, { FunctionComponent } from 'react';
import { PackageChoiceButton } from 'react-design-components';
import { PackageChoiceWrapper } from '../Elements';
import { PartnerProduct } from '../../services/PartnerService';
import usePackageSelector from './hooks/usePackageSelector';

export type PartnerProductWithRefrenceInput = (PartnerProduct | undefined) & {
  error?: string;
  onReferenceChange?: (event: any) => void;
  referenceLabel?: string;
  reference?: string;
  logoCompensation?: boolean;
  legalInsuranceConsent?: boolean;
  legalInsuranceConsentError?: string;
  onLegalInsuranceConsentChange?: (event: any) => void;
  billingConsent?: boolean;
  billingConsentError?: string;
  onBillingConsentChange?: (event: any) => void;
  requiresUnionOptionsConsent?: boolean;
  unionOptionsConsent?: boolean;
  unionOptionsConsentError?: string;
  onUnionOptionsChange?: (event: any) => void;
};

export interface Props {
  products?: Array<PartnerProductWithRefrenceInput>;
  onSelect?: (e: any) => void;
  isDisabled: (product: PartnerProduct) => boolean;
}

const PackageSelector: FunctionComponent<Props> = (props: Props) => {
  const { products, isDisabled } = props;

  const { t, price, initialPrice, onProductSelect } = usePackageSelector(props);
  return (
    <PackageChoiceWrapper>
      {products &&
        products.map((product: PartnerProductWithRefrenceInput) => (
          <PackageChoiceButton
            key={product.id}
            t={t}
            onClick={() => onProductSelect(product.id)}
            product={{
              name: product.name,
              priceGross: price(product),
              descriptions: product.attributesIncluded,
              descriptionsNotIncluded: product.attributesExcluded,
              initialPriceGross: initialPrice(product),
              logo: product.integratedPartner.partnerSettings.productLogo,
            }}
            disabled={isDisabled(product)}
            unavailable={product.unavailable}
            highlighted={product.highlighted}
            hidePrice={product.hidePrice}
            onReferenceChange={product.onReferenceChange}
            referenceLabel={product.referenceLabel}
            error={product.error}
            reference={product.reference}
            logoCompensation={product.logoCompensation}
            requiresInsuranceConsent={product.requiresInsuranceProof}
            legalInsuranceConsent={product.legalInsuranceConsent}
            legalInsuranceConsentError={product.legalInsuranceConsentError}
            onLegalInsuranceConsentChange={product.onLegalInsuranceConsentChange}
            requiresBillingConsent={product.requiresBillingConsent}
            billingConsent={product.billingConsent}
            billingConsentError={product.billingConsentError}
            onBillingConsentChange={product.onBillingConsentChange}
            requiresUnionOptionsConsent={product.requiresUnionOptionsConsent}
            unionOptionsConsent={product.unionOptionsConsent}
            unionOptionsConsentError={product.unionOptionsConsentError}
            onUnionOptionsChange={product.onUnionOptionsChange}
          />
        ))}
    </PackageChoiceWrapper>
  );
};

PackageSelector.defaultProps = {
  products: undefined,
  onSelect: undefined,
};

export default PackageSelector;
